import dayjs from 'dayjs';
import { h } from 'preact';

import { IconThumbtack } from '../../../../common/icons/icon-thumbtack';
import { IconUserCircle } from '../../../../common/icons/icon-user-circle';
import { linkify } from '../../../../utils/a11y.utils';
import { avatarGradient } from '../../../avatar-gradient';
import type { Post } from '../../../model/post.interface';
import { AVATAR_BADGE_SIZE_PX, PerksBadge } from '../../perks-badge/perks-badge.component';

interface Props {
  post: Post;
  showPostAuthor: boolean;
  goToPost: (comments?: boolean) => void;
}

export const PerksPostCreator = ({ post, showPostAuthor, goToPost }: Props) => {
  return (
    <div class="single-post-creator">
      {showPostAuthor && (
        <>
          <div class="single-post-avatar" onClick={() => goToPost(false)}>
            {post.authors[0].imageUrl ? (
              <img src={post.authors[0].imageUrl} alt="" />
            ) : post.authors[0].official === false && post.authors[0].userId ? (
              // a fan submission's byline: the fan's own gradient, as on their comments
              <span
                class="single-avatar-gradient"
                style={{ background: avatarGradient(post.authors[0].userId) }}
              >
                <IconUserCircle width={45} height={45} fill="#fff" />
              </span>
            ) : (
              <IconUserCircle width={45} height={45} />
            )}
            {/* official authors are the artist; the hidden authors minted for fan submissions are not */}
            {post.authors[0].official !== false && (
              <PerksBadge kind="artist" size={AVATAR_BADGE_SIZE_PX} />
            )}
          </div>
          <div class="single-post-author" {...linkify(() => goToPost(false))}>
            <h5>{post.authors[0].name}</h5>
            <p>{dayjs(post.publishedAt).format('MMM D, YYYY')}</p>
          </div>
        </>
      )}
      {post.pinned && (
        <div class="single-post-pinned">
          <IconThumbtack />
        </div>
      )}
    </div>
  );
};
